// ----------------------------------------------------------------------

export default function Lists(theme) {
  return {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'inherit',
          minWidth: 'auto',
          marginRight: theme.spacing(2)
        }
      }
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
          marginRight: theme.spacing(2)
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginTop: 0,
          marginBottom: 0,
          '& a': {
            color: theme.palette.brand.link,
            fontWeight: theme.palette.mode === 'dark' ? 600 : 500,
            textDecoration: 'none',
            textUnderlineOffset: 4,
            '&:hover': {
              color: theme.palette.brand.linkHover,
              textDecoration: 'underline'
            }
          }
        },
        multiline: {
          marginTop: 0,
          marginBottom: 0
        }
      }
    }
  };
}
